import React from 'react';
import PropTypes from 'prop-types';
import WindowSizeListener from 'react-window-size-listener';

function WSL(props) {
  return (
    <WindowSizeListener onResize={props.onResize} />
  );
}

WSL.propTypes = {
  onResize: PropTypes.func.isRequired,
};
WSL.defaultProps = {
};

export default WSL;
